export default __webpack_public_path__ + "static/Idea@mob_2x-13de2b5ad1f1740351024dc8a45ca1ff.png";